/**
 * AlphaX ECU Choice Helper - Interactive Logic & Bilingual Engine (EN / ES)
 * Pure Recommendation & Storefront Purchasing Advisor
 */

(function () {
  'use strict';

  // Master Database from eculist.ods
  const ECU_DATABASE = [
  {
    "ProductID": "PROD-UNI-IRON",
    "Name": "AlphaECU Iron",
    "Category": "universal",
    "Make": "Universal",
    "Model": "2-Channel Standalone / Piggyback",
    "CurrentRevision": "Rev 1.3",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$349",
    "JobberPrice": "$280",
    "DealerPrice": "$240",
    "CoreRequired": "No",
    "ProcessorArch": "STM32 168MHz BlackPill",
    "Channels": "2 Injector / 2 Ignition / VR+Hall",
    "Description": "Computadora 2 canales para usar en conjunto con una ECU de fábrica o independientemente",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/iron_pinout.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/iron_base.bin",
    "StockQty": "17",
    "CasesQty": "6",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-UNI-COPPER",
    "Name": "AlphaECU Copper",
    "Category": "universal",
    "Make": "Universal",
    "Model": "4-Channel Standalone / Piggyback",
    "CurrentRevision": "Rev 1.4",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$449",
    "JobberPrice": "$360",
    "DealerPrice": "$310",
    "CoreRequired": "No",
    "ProcessorArch": "STM32 168MHz BlackPill",
    "Channels": "4 Injector / 4 Ignition / VR+Hall / Boost Control",
    "Description": "Computadora 4 canales para uso independiente o piggyback",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/copper_pinout.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/copper_base.bin",
    "StockQty": "2",
    "CasesQty": "5",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-UNI-BRONZE",
    "Name": "AlphaECU Bronze",
    "Category": "universal",
    "Make": "Universal",
    "Model": "4-Channel Advanced Dual-Map",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$499",
    "JobberPrice": "$400",
    "DealerPrice": "$350",
    "CoreRequired": "No",
    "ProcessorArch": "STM32 168MHz BlackPill",
    "Channels": "4 Injector / 4 Ignition / Boost / Launch / Dual Map",
    "Description": "Computadora 4 canales avanzada con switch de doble mapa",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/bronze_pinout.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/bronze_base.bin",
    "StockQty": "2",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-UNI-SILVER",
    "Name": "AlphaECU Silver",
    "Category": "universal",
    "Make": "Universal",
    "Model": "6-Channel + Wideband WBO2",
    "CurrentRevision": "Rev 2.0",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$599",
    "JobberPrice": "$480",
    "DealerPrice": "$420",
    "CoreRequired": "No",
    "ProcessorArch": "STM32 168MHz + LSU4.9 Driver",
    "Channels": "6 Injector / 6 Ignition / Built-in Wideband LSU 4.9",
    "Description": "Computadora 6 canales con wideband integrado",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/silver_pinout.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/silver_base.bin",
    "StockQty": "5",
    "CasesQty": "2",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-UNI-GOLD",
    "Name": "AlphaECU Gold",
    "Category": "universal",
    "Make": "Universal",
    "Model": "8-Channel V8 Standalone",
    "CurrentRevision": "Rev 2.1",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$999",
    "JobberPrice": "$800",
    "DealerPrice": "$700",
    "CoreRequired": "No",
    "ProcessorArch": "STM32 168MHz BlackPill",
    "Channels": "8 Injector / 8 Ignition / Dual Wideband / CANBUS",
    "Description": "Computadora 8 canales para motores V8 de alto desempeño",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/gold_pinout.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/gold_base.bin",
    "StockQty": "5",
    "CasesQty": "5",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-UNI-PLATINUM",
    "Name": "AlphaECU Platinum",
    "Category": "universal",
    "Make": "Universal",
    "Model": "12-Channel V12 / Dual DBW",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"testing_validation\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,999",
    "JobberPrice": "$1,600",
    "DealerPrice": "$1,400",
    "CoreRequired": "No",
    "ProcessorArch": "Dual STM32 High-Speed",
    "Channels": "12 Injector / 12 Ignition / Dual DBW / 4 VVT / Dual CAN",
    "Description": "Computadora 12 canales insignia para motores de 10 y 12 cilindros",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/platinum_pinout.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/platinum_base.bin",
    "StockQty": "3",
    "CasesQty": "0",
    "CreatedAt": "2026-02-15T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-UNI-GDI4K",
    "Name": "AlphaECU 4K GDi",
    "Category": "universal",
    "Make": "Universal",
    "Model": "4-Channel Direct Injection (GDI)",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"testing_validation\", \"need_engineering_rev\"]",
    "LifecycleStatus": "obsolete",
    "MSRP": "$2,149",
    "JobberPrice": "$1,720",
    "DealerPrice": "$1,500",
    "CoreRequired": "No",
    "ProcessorArch": "STM32 + High Voltage 65V Boost",
    "Channels": "4 GDi Peak & Hold + High Pressure Pump Control",
    "Description": "Computadora 4 canales de Inyección Directa GDi (Prototipo cancelado / Nunca salió de desarrollo)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/gdi4k_pinout.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/gdi4k_base.bin",
    "StockQty": "0",
    "CasesQty": "0",
    "CreatedAt": "2026-03-01T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-UNI-NEO2",
    "Name": "AlphaECU 2chan Neo+",
    "Category": "universal",
    "Make": "Universal",
    "Model": "2-Channel Standalone 168MHz",
    "CurrentRevision": "Rev 1.1",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "obsolete",
    "MSRP": "$699",
    "JobberPrice": "$560",
    "DealerPrice": "$490",
    "CoreRequired": "No",
    "ProcessorArch": "STM32 168MHz Neo Core",
    "Channels": "2 Injector / 2 Ignition / Onboard Bluetooth",
    "Description": "Computadora 2 canales 168MHz (Línea descontinuada)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/neo2_pinout.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/neo2_base.bin",
    "StockQty": "0",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-UNI-NEO4",
    "Name": "AlphaECU 4chan Neo+",
    "Category": "universal",
    "Make": "Universal",
    "Model": "6-Channel DBW & Dual VVT",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "obsolete",
    "MSRP": "$899",
    "JobberPrice": "$720",
    "DealerPrice": "$630",
    "CoreRequired": "No",
    "ProcessorArch": "STM32 168MHz Neo Core",
    "Channels": "6 Channels / Drive-By-Wire (DBW) / Dual VVT / CANBUS",
    "Description": "Computadora 4/6 canales Neo+ (Línea descontinuada)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/neo4_pinout.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/neo4_base.bin",
    "StockQty": "0",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-UNI-BRAINBOARD",
    "Name": "AlphaECU Brainboard (Rojo / Blanco)",
    "Category": "universal",
    "Make": "Universal",
    "Model": "Core MCU Processor Board",
    "CurrentRevision": "Rev 2.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$149",
    "JobberPrice": "$120",
    "DealerPrice": "$100",
    "CoreRequired": "N/A",
    "ProcessorArch": "STM32F407 168MHz",
    "Channels": "Modular MCU daughterboard for all AlphaECU motherboards",
    "Description": "Procesador principal de muchas AlphaECU (Disponible en Brainboard Rojo y Brainboard Blanco)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/brainboard_pinout.pdf",
    "BaseTuneUrl": "",
    "StockQty": "70",
    "CasesQty": "N/A",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-BMW-E30M20",
    "Name": "BMW E30 M20",
    "Category": "plugin",
    "Make": "BMW",
    "Model": "E30 325i M20B25 1987-1991 (Motronic 1.1/1.3)",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "6-Cylinder Wasted Spark / 60-2 VR Trigger / Idle ICV",
    "Description": "Computadora PNP para BMW M20",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/bmw_e30_m20.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/m20b25_base.bin",
    "StockQty": "2",
    "CasesQty": "1",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-BMW-E36M50",
    "Name": "BMW E36 M50",
    "Category": "plugin",
    "Make": "BMW",
    "Model": "E36 325i M50B25 Non-Vanos & Vanos",
    "CurrentRevision": "Rev 1.4",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "Shared Case (2)",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "6-Cylinder Sequential / Single Vanos / Factory Idle ICV",
    "Description": "Computadora PNP para BMW M50 (caja compartida con M52)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/bmw_e36_m50.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/m50b25_base.bin",
    "StockQty": "3",
    "CasesQty": "2",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-BMW-E36M52",
    "Name": "BMW E36 M52",
    "Category": "plugin",
    "Make": "BMW",
    "Model": "E36 328i/M3 M52B28 / S52 (OBD2)",
    "CurrentRevision": "Rev 1.4",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "Shared Case",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "6-Cylinder Sequential / Dual Knock / Factory Temp Gauge",
    "Description": "Computadora PNP para BMW M52 (caja compartida con M50)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/bmw_e36_m52.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/m52b28_base.bin",
    "StockQty": "2",
    "CasesQty": "2",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-BMW-E46M54",
    "Name": "BMW E46 M54 (MS43)",
    "Category": "plugin",
    "Make": "BMW",
    "Model": "E46 325i/330i M54B25/M54B30",
    "CurrentRevision": "Rev 1.1",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "2",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Dual Vanos / DBW / CANBUS Instrument Cluster Integration",
    "Description": "Computadora PNP para BMW M54",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/bmw_e46_m54.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/m54b30_base.bin",
    "StockQty": "4",
    "CasesQty": "2",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-CHEV-VETTEC6",
    "Name": "Chevy Corvette C6",
    "Category": "plugin",
    "Make": "Chevrolet",
    "Model": "Corvette C6 LS2 / LS3 / LS7 6.0L-7.0L",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,900",
    "JobberPrice": "$1,520",
    "DealerPrice": "$1,330",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard Dual Core",
    "Channels": "58X Crank Trigger / Dual DBW / V8 Sequential / Full CANBUS",
    "Description": "Computadora PNP para Chevrolet Corvette C6 LS2/LS3",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/chevy_corvette_c6.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/ls3_c6_base.bin",
    "StockQty": "2",
    "CasesQty": "1",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-CHEV-CAMAROLS",
    "Name": "Chevy Camaro Fifth Gen LS",
    "Category": "plugin",
    "Make": "Chevrolet",
    "Model": "Camaro SS 6.2L LS3 / L99 Gen 5",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$2,999",
    "JobberPrice": "$2,400",
    "DealerPrice": "$2,100",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard Dual Core",
    "Channels": "V8 Sequential / DBW Throttle / VVT / Active Fuel Management delete",
    "Description": "Computadora PNP para Chevrolet Camaro 6.2",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/chevy_camaro_ls.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/camaro_ls3_base.bin",
    "StockQty": "1",
    "CasesQty": "0",
    "CreatedAt": "2026-02-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-DODGE-HEMIGPEC2A",
    "Name": "Dodge Hemi GPEC2A",
    "Category": "plugin",
    "Make": "Dodge",
    "Model": "Hemi 5.7L / 6.2L Hellcat / 6.4L 392 ScatPack",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"testing_validation\", \"need_engineering_rev\"]",
    "LifecycleStatus": "active",
    "MSRP": "$2,999",
    "JobberPrice": "$2,400",
    "DealerPrice": "$2,100",
    "CoreRequired": "No",
    "ProcessorArch": "High-Speed Tri-Core Architecture",
    "Channels": "Dual DBW / Variable Cam Timing VCT / Supercharger Bypass / CAN Gateway",
    "Description": "Computadora Plugin para Dodge Hemi 5.7/6.2/6.4 GPEC2A",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/dodge_hemi_gpec2a.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/hemi_64_base.bin",
    "StockQty": "1",
    "CasesQty": "0",
    "CreatedAt": "2026-03-01T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-FORD-FOX8695",
    "Name": "Ford Mustang 86-95 (Foxbody / SN95)",
    "Category": "plugin",
    "Make": "Ford",
    "Model": "Mustang 5.0 302 / 3.8 V6 1986-1995",
    "CurrentRevision": "Rev 2.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "1 (shared foxbody)",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP TFI Ignition Module / 8 Injectors / Mass Air or Speed Density",
    "Description": "Computadora PNP para Mustang 302/V6 (comparte caja foxbody)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/ford_foxbody_302.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/foxbody_302_base.bin",
    "StockQty": "3",
    "CasesQty": "1",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-FORD-SN9604",
    "Name": "Ford Mustang 96-04 (4.6 2V)",
    "Category": "plugin",
    "Make": "Ford",
    "Model": "Mustang 4.6L Modular 2V / V6 1996-2004",
    "CurrentRevision": "Rev 1.3",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "1 (shared foxbody)",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP 4.6 2V Modular EDIS / Wasted Spark / Cluster integration",
    "Description": "Computadora PNP para Mustang 4.6/V6 1996-1998 y 1999-2004",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/ford_mustang_46.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/mustang_46_base.bin",
    "StockQty": "4",
    "CasesQty": "1",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-FORD-S1973V",
    "Name": "Ford Mustang 05-11 (4.6 3V)",
    "Category": "plugin",
    "Make": "Ford",
    "Model": "Mustang GT 4.6L 3-Valve S197 2005-2010",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32 + VVT Driver",
    "Channels": "Dual VCT / Drive-By-Wire / CMCV Runner Control / CAN Cluster",
    "Description": "Computadora Plugin para Mustang 4.6 3V",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/ford_mustang_46_3v.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/mustang_3v_base.bin",
    "StockQty": "2",
    "CasesQty": "1",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-FORD-S197COYOTE",
    "Name": "Ford Mustang 12-14 (S197 Coyote 5.0 4V)",
    "Category": "plugin",
    "Make": "Ford",
    "Model": "Mustang GT Coyote 5.0 4V 2011-2014",
    "CurrentRevision": "Rev A",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$2,000",
    "JobberPrice": "$1,600",
    "DealerPrice": "$1,400",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32 + Ti VVT Driver",
    "Channels": "Quad Ti-VCT Cam Control / DBW / CAN Gateway",
    "Description": "Computadora Plugin para Mustang 5.0 4V Coyote 2012-2014",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/ford_s197_coyote.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/s197_coyote_base.bin",
    "StockQty": "2",
    "CasesQty": "1",
    "CreatedAt": "2026-02-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-FORD-S550",
    "Name": "Ford Mustang 15-17 (S550 Coyote V1/V2)",
    "Category": "plugin",
    "Make": "Ford",
    "Model": "Mustang GT Coyote 5.0 4V S550 2015-2017",
    "CurrentRevision": "Rev 2.0",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$2,999",
    "JobberPrice": "$2,400",
    "DealerPrice": "$2,100",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard Dual Core",
    "Channels": "Quad VVT / Direct Injection Secondary / Full CANBUS",
    "Description": "Computadora Plugin para Mustang 5.0 4V 2015-2017 S550",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/ford_s550.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/s550_coyote_base.bin",
    "StockQty": "2",
    "CasesQty": "1",
    "CreatedAt": "2026-03-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-HON-8THGEN",
    "Name": "Honda Civic 8th Gen (FG2/FA5)",
    "Category": "plugin",
    "Make": "Honda",
    "Model": "Civic 8th Gen K20Z3 2006-2011",
    "CurrentRevision": "Rev 1.1",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "3",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Full PNP / DBW / CANBUS Gauges / EPS Assist",
    "Description": "Computadora PNP para Honda Civic Si 8va Generación K20Z3 con ETB y cluster funcional",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/honda_8thgen.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/k20z3_8thgen_base.bin",
    "StockQty": "9",
    "CasesQty": "3",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-12T10:00:00Z"
  },
  {
    "ProductID": "PROD-HON-S2000",
    "Name": "Honda S2000 AP1",
    "Category": "plugin",
    "Make": "Honda",
    "Model": "S2000 AP1 F20C 2000-2005",
    "CurrentRevision": "Rev 1.3",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "4",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Full PNP / VTEC Control / Factory Cluster Temp & Tach",
    "Description": "Computadora PNP para Honda S2000 AP1 F20C",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/honda_s2000_ap1.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/s2000_ap1_base.bin",
    "StockQty": "3",
    "CasesQty": "4",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-HON-EP3RSX",
    "Name": "Honda EP3 / RSX (Serie K Swap)",
    "Category": "plugin",
    "Make": "Honda",
    "Model": "EP3 Civic Si / RSX / K-Swap EG/EK",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,000",
    "JobberPrice": "$800",
    "DealerPrice": "$700",
    "CoreRequired": "2 (Core: 2)",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP K-Series K20A/A2/A3 / VTC / VTEC",
    "Description": "Computadora PNP para Honda Serie K EG/RSX",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/honda_kseries_ep3.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/k20a2_base.bin",
    "StockQty": "2",
    "CasesQty": "2",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-HON-SERIEB",
    "Name": "Honda Serie B P28",
    "Category": "plugin",
    "Make": "Honda",
    "Model": "Civic/Integra B16/B18/B20 (OBD1)",
    "CurrentRevision": "Rev 1.4",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "5",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP OBD1 P28 Harness / VTEC / Hall or VR Distributor",
    "Description": "Computadora PNP para Honda Serie B con rabiza P28",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/honda_p28.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/b18c_base.bin",
    "StockQty": "16",
    "CasesQty": "5",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-HON-KRUSO",
    "Name": "Honda Serie K EG/RSX Ruso",
    "Category": "plugin",
    "Make": "Honda",
    "Model": "Serie K EG/EK Swap Harness Ruso",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,000",
    "JobberPrice": "$800",
    "DealerPrice": "$700",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Custom Russian pinout architecture for K-Swap",
    "Description": "Computadora PNP para Honda Serie K EG/RSX Ruso",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/honda_k_ruso.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/k20_ruso_base.bin",
    "StockQty": "1",
    "CasesQty": "0",
    "CreatedAt": "2026-04-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-HON-KDESIGNV1",
    "Name": "K Series Alpha Design V1",
    "Category": "plugin",
    "Make": "Honda",
    "Model": "K-Series Custom Integrated Architecture",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"testing_validation\", \"need_engineering_rev\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,200",
    "JobberPrice": "$960",
    "DealerPrice": "$840",
    "CoreRequired": "No",
    "ProcessorArch": "Integrated STM32 Single Board",
    "Channels": "Direct K20/K24 Integrated PCB / Dual Wideband",
    "Description": "Nueva arquitectura integrada Single-Board para Honda K-Series",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/kseries_alphav1.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/kseries_v1_base.bin",
    "StockQty": "2",
    "CasesQty": "0",
    "CreatedAt": "2026-04-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-HYU-ACCENT1",
    "Name": "Hyundai Accent Gen1 (1994-1999)",
    "Category": "plugin",
    "Make": "Hyundai",
    "Model": "Accent 1.5L SOHC/DOHC 1994-1999",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "deprecated",
    "MSRP": "$600",
    "JobberPrice": "$480",
    "DealerPrice": "$420",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "4-Cylinder Sequential / Wasted Spark / Factory Idle ICV",
    "Description": "Computadora Plug and Play para Hyundai Accent 1.5 1994-1999",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_accent_gen1.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/accent15_base.bin",
    "StockQty": "0",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-HYU-ACCENT2",
    "Name": "Hyundai Accent Gen2 (2000-2006)",
    "Category": "plugin",
    "Make": "Hyundai",
    "Model": "Accent 1.5L/1.6L Alpha 2000-2006",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "deprecated",
    "MSRP": "$600",
    "JobberPrice": "$480",
    "DealerPrice": "$420",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "4-Cylinder Sequential / 60-2 VR Trigger / Factory Tach",
    "Description": "Computadora Plug and Play para Hyundai Accent 1.5 2000-2006",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_accent_gen2.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/accent16_base.bin",
    "StockQty": "0",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-HYU-GENESIS20T",
    "Name": "Hyundai Genesis Coupe 2.0T",
    "Category": "plugin",
    "Make": "Hyundai",
    "Model": "Genesis Coupe 2.0T Theta 2010-2014",
    "CurrentRevision": "Rev 1.3",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "N/A",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Dual CVVT / DBW / Boost Solenoid / CANBUS Gauges",
    "Description": "Computadora Plug and Play para Hyundai Genesis Coupe 2.0T 2010-2014",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_genesis_20t.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/genesis_20t_base.bin",
    "StockQty": "12",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-HYU-TIBURONB1",
    "Name": "Hyundai Tiburon Beta1",
    "Category": "plugin",
    "Make": "Hyundai",
    "Model": "Tiburon 2.0L Beta 1 1997-2001",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "deprecated",
    "MSRP": "$600",
    "JobberPrice": "$480",
    "DealerPrice": "$420",
    "CoreRequired": "1",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "4-Cylinder / Wasted Spark / Idle PWM",
    "Description": "Computadora Plug and Play para Hyundai Tiburon 2.0 1997-2001",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_tiburon_b1.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/tiburon_b1_base.bin",
    "StockQty": "1",
    "CasesQty": "1",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-HYU-TIBURONB2",
    "Name": "Hyundai Tiburon Beta2",
    "Category": "plugin",
    "Make": "Hyundai",
    "Model": "Tiburon 2.0L Beta 2 VVT 2003-2007",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "deprecated",
    "MSRP": "$700",
    "JobberPrice": "$560",
    "DealerPrice": "$490",
    "CoreRequired": "1",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "4-Cylinder / CVVT Vane Control / Idle ICV",
    "Description": "Computadora Plug and Play para Hyundai Tiburon 2.0 2003-2007",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_tiburon_b2.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/tiburon_b2_base.bin",
    "StockQty": "0",
    "CasesQty": "1",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-HYU-TIBURONV6",
    "Name": "Hyundai Tiburon V6 (2.7L Delta)",
    "Category": "plugin",
    "Make": "Hyundai",
    "Model": "Tiburon GT 2.7L Delta V6 2003-2007",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "3",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "V6 Sequential Injection / Wasted Spark / Idle ICV",
    "Description": "Computadora Plug and Play para Hyundai Tiburon 2.7 2003-2007",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_tiburon_v6.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/tiburon_v6_base.bin",
    "StockQty": "8",
    "CasesQty": "3",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-KIA-RIO2008",
    "Name": "Kia Rio 2008 (Beta/Alpha)",
    "Category": "plugin",
    "Make": "Kia",
    "Model": "Kia Rio 1.6L Alpha/Beta II 2006-2011",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "deprecated",
    "MSRP": "$600",
    "JobberPrice": "$480",
    "DealerPrice": "$420",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "4-Cylinder Sequential / VVT Cam Sync",
    "Description": "Computadora para Hyundai/Kia last beta engine",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/kia_rio_2008.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/kia_rio_base.bin",
    "StockQty": "0",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-MAZ-MIATANA",
    "Name": "Mazda Miata NA 1989-96",
    "Category": "plugin",
    "Make": "Mazda",
    "Model": "Miata NA 1.6L B6-ZE / 1.8L BP-4W 1989-1996",
    "CurrentRevision": "Rev 2.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "3",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP CAS Optical / Wasted Spark / Factory AC switch",
    "Description": "Computadora PNP para Mazda Miata NA 1.6/1.8",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/mazda_miata_na.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/miata_na_base.bin",
    "StockQty": "15",
    "CasesQty": "3",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-MAZ-MIATANB1",
    "Name": "Mazda Miata NB 1999-00",
    "Category": "plugin",
    "Make": "Mazda",
    "Model": "Miata NB1 1.8L BP-4W 1999-2000",
    "CurrentRevision": "Rev 2.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "1",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP NB Trigger / Wasted Spark / Factory Alternator Field Control",
    "Description": "Computadora PNP para Mazda Miata NB 1.8 1999-2000",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/mazda_miata_nb1.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/miata_nb1_base.bin",
    "StockQty": "2",
    "CasesQty": "2",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-MAZ-MIATANB2",
    "Name": "Mazda Miata NB2 00-02 (VVT)",
    "Category": "plugin",
    "Make": "Mazda",
    "Model": "Miata NB2 1.8L BP-Z3 VVT 2000-2005",
    "CurrentRevision": "Rev 2.1",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "1",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP NB Trigger / VVT Cam Angle Control / Alternator Field Control",
    "Description": "Computadora PNP para Mazda Miata NB 1.8 2000-2002 con VVT",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/mazda_miata_nb2.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/miata_nb2_base.bin",
    "StockQty": "4",
    "CasesQty": "2",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-MAZ-PROTEGE",
    "Name": "Mazda Protege (1.8L / 2.0L)",
    "Category": "plugin",
    "Make": "Mazda",
    "Model": "Protege / Protege5 1.8L FP-DE / 2.0L FS-DE",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "deprecated",
    "MSRP": "$750",
    "JobberPrice": "$600",
    "DealerPrice": "$525",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "4-Cylinder Sequential / Wasted Spark / Idle ICV",
    "Description": "Computadora PNP para Mazda Protege / Protege5",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/mazda_protege.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/protege_fs_base.bin",
    "StockQty": "0",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-MINI-R53",
    "Name": "Mini Cooper R53 Supercharger",
    "Category": "plugin",
    "Make": "Mini",
    "Model": "Mini Cooper S 1.6L Supercharged W11 2002-2006",
    "CurrentRevision": "Rev 1.3",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "2",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "DBW Throttle / Supercharger Bypass / Full CANBUS Dash",
    "Description": "Computadora PNP para Mini Cooper Supercharger 1.6",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/mini_r53.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/mini_r53_base.bin",
    "StockQty": "4",
    "CasesQty": "2",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-MITS-3000GT",
    "Name": "Mitsubishi 3000GT / Stealth (6G72)",
    "Category": "plugin",
    "Make": "Mitsubishi",
    "Model": "3000GT / Stealth 3.0L V6 6G72 DOHC Turbo / NA",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "3",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "6-Cylinder / Optical / Hall Cam-Crank Sync / Dual Turbo Wastegate",
    "Description": "Computadora PNP para Mitsubishi 3000GT / Stealth 6G72",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/mits_3000gt.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/3000gt_6g72_base.bin",
    "StockQty": "5",
    "CasesQty": "3",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-MITS-ECLIPSE6G75",
    "Name": "Mitsubishi Eclipse 06+ (6G75 3.8L)",
    "Category": "plugin",
    "Make": "Mitsubishi",
    "Model": "Eclipse 4G 3.8L V6 6G75 MIVEC 2006-2012",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "V6 MIVEC / DBW / Crank-Cam Sync / Parallel 1K Resistor rework",
    "Description": "Computadora PNP para Mitsubishi Eclipse 4G 3.8 6G75 2006+",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/mits_eclipse_38.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/eclipse_6g75_base.bin",
    "StockQty": "4",
    "CasesQty": "3",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-MITS-LANCER4B",
    "Name": "Mitsubishi Lancer 4Bxx (2008+)",
    "Category": "plugin",
    "Make": "Mitsubishi",
    "Model": "Lancer 2.0L/2.4L 4B11 / 4B12 2008+",
    "CurrentRevision": "Rev 1.3",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "Core or +$50",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP 4B11 / DBW / MIVEC / CANBUS Dash Integration",
    "Description": "Computadora PNP para Lancer 2008+ motor 4b11 y 4b12",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/mits_4b11.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/4b11_base.bin",
    "StockQty": "14",
    "CasesQty": "5",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-MITS-MRMD",
    "Name": "Mitsubishi MR/MD (Tecnica / Evo 4-8)",
    "Category": "plugin",
    "Make": "Mitsubishi",
    "Model": "Tecnica 97-02 / Lancer Evo 4-8 / Mirage",
    "CurrentRevision": "Rev 1.3 (V13)",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "5",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP 4G93/4G63 / Factory Stepper Idle / VR+Hall",
    "Description": "Computadora PNP para Tecnica 97-2002, Evolution 4-8, varias otras",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/mits_tecnica.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/4g93_tecnica_base.bin",
    "StockQty": "17",
    "CasesQty": "5",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-MITS-RALLIART",
    "Name": "Mitsubishi Ralliart 04-06",
    "Category": "plugin",
    "Make": "Mitsubishi",
    "Model": "Lancer Ralliart 2.4L 4G69 MIVEC 2004-2006",
    "CurrentRevision": "Rev 1.1",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "Core or +$100",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP 4G69 / DBW / MIVEC Variable Valve Lift",
    "Description": "Computadora PNP para Lancer Ralliart 2004-2006 4G69",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/mits_ralliart.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/4g69_ralliart_base.bin",
    "StockQty": "6",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-MITS-MIRAGEG4",
    "Name": "Mitsubishi Mirage G4 (3A92)",
    "Category": "plugin",
    "Make": "Mitsubishi",
    "Model": "Mirage / Attrage G4 1.2L 3A92 3-Cylinder",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$600",
    "JobberPrice": "$480",
    "DealerPrice": "$420",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "3-Cylinder Sequential / MIVEC VVT / DBW Throttle",
    "Description": "Computadora PNP para Mitsubishi Mirage G4 3A92",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/mits_mirage_g4.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/mirage_g4_base.bin",
    "StockQty": "0",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-NIS-SKYLINE",
    "Name": "Nissan Skyline R32/R33/R34 (GTT/GTR)",
    "Category": "plugin",
    "Make": "Nissan",
    "Model": "Skyline R32 / R33 / R34 RB20 / RB25 / RB26DETT",
    "CurrentRevision": "Rev 1.1",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,200",
    "JobberPrice": "$960",
    "DealerPrice": "$840",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "6-Cylinder Sequential / CAS Optical / VTC / Twin Turbo Boost",
    "Description": "Computadora PNP para Nissan Skyline R32, R33, R34 GTT y GTR con motor RB20/25/26",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/nissan_skyline_rb.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/skyline_rb26_base.bin",
    "StockQty": "4",
    "CasesQty": "2",
    "CreatedAt": "2026-02-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-NIS-350Z",
    "Name": "Nissan 350Z (VQ35DE)",
    "Category": "plugin",
    "Make": "Nissan",
    "Model": "350Z / G35 VQ35DE 2003-2006",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "N/A",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Dual VTC / Drive-By-Wire / Full CANBUS Cluster Integration",
    "Description": "Computadora Plug and Play para Nissan 350Z VQ35DE",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/nissan_350z.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/350z_vq35de_base.bin",
    "StockQty": "3",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-NIS-S131415",
    "Name": "Nissan S13/14/15 (SR20DET)",
    "Category": "plugin",
    "Make": "Nissan",
    "Model": "Silvia / 240SX SR20DET / KA24DE",
    "CurrentRevision": "Rev 1.4",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "2",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "CAS Optical Trigger / VVT Cam Switch / Boost Control",
    "Description": "Computadora PNP para Nissan SR20DET y KA24DE",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/nissan_sr20det.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/sr20det_base.bin",
    "StockQty": "6",
    "CasesQty": "2",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-SUB-RSEJ20",
    "Name": "Subaru RS Ej20 2000-07",
    "Category": "plugin",
    "Make": "Subaru",
    "Model": "Impreza RS 2.5L / EJ20 N/A 2000-2007",
    "CurrentRevision": "Rev 1.1",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$499",
    "JobberPrice": "$400",
    "DealerPrice": "$350",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "6/7 Subaru Trigger / Wasted Spark / Idle PWM",
    "Description": "Computadora PNP para Subaru RS EJ20 2000-2007",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/subaru_rs_ej20.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/ej20_na_base.bin",
    "StockQty": "2",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-SUB-WRXEJ20",
    "Name": "Subaru WRX Ej20 2000-07",
    "Category": "plugin",
    "Make": "Subaru",
    "Model": "Impreza WRX Turbo EJ205 2000-2007",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "AVCS Intake VVT / Wasted Spark / Boost Control Solenoid",
    "Description": "Computadora PNP para Subaru WRX EJ20 2000-2007",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/subaru_wrx_ej20.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/wrx_ej205_base.bin",
    "StockQty": "1",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-SUB-WRXSTI",
    "Name": "Subaru WRX STi 04-06 (EJ207/257)",
    "Category": "plugin",
    "Make": "Subaru",
    "Model": "WRX STi EJ257 / EJ207 2004-2006",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,000",
    "JobberPrice": "$800",
    "DealerPrice": "$700",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Dual AVCS / Drive-By-Wire / Dual Knock / Intercooler Spray",
    "Description": "Computadora PNP para Subaru WRX EJ207/EJ257 2004-2006",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/subaru_wrx_sti.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/sti_ej257_base.bin",
    "StockQty": "1",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-TOY-COR9702",
    "Name": "Toyota Corolla 97-02 (4A/7A)",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Corolla 1.6L 4A-FE / 1.8L 7A-FE 1997-2002",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "2",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Distributor Hall / Wasted Spark / Idle ICV",
    "Description": "Computadora PNP para Toyota Corolla 97-02 4AFE/7AFE (incluye 7A-FE)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/toyota_corolla_9702.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/7afe_base.bin",
    "StockQty": "15",
    "CasesQty": "2",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-TOY-COR0304",
    "Name": "Toyota Corolla 03-04 (1ZZ)",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Corolla / Matrix 1.8L 1ZZ-FE Cable Throttle 2003-2004",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "Shared Case",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "36-2 VR Crank / VVT-i Cam / Idle PWM",
    "Description": "Computadora PNP para Toyota Corolla 03-04 1ZZ",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/toyota_corolla_0304.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/1zz_0304_base.bin",
    "StockQty": "5",
    "CasesQty": "2",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-TOY-2ZZ0506",
    "Name": "Toyota Corolla/Matrix XRS 05-06",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Corolla / Matrix XRS 2ZZ-GE (DBW 05-06)",
    "CurrentRevision": "Rev 1.5",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "5 (Shared with Matrix)",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP 2ZZ-GE / DBW / VVTL-i Cam Lift switch",
    "Description": "Computadora PNP para Toyota Corolla y Matrix 2ZZ 05-06",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/toyota_2zz_0506.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/2zz_0506_base.bin",
    "StockQty": "10",
    "CasesQty": "5",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-TOY-MATRIX2ZZ",
    "Name": "Toyota Matrix 2zz 03-04",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Matrix XRS / Celica GTS 2ZZ-GE Cable Throttle 2003-2004",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "5 (Shared with Corolla)",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP 2ZZ-GE Cable Throttle / Lift VVL",
    "Description": "Computadora PNP para Toyota Matrix 2003-2004",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/toyota_2zz_0304.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/2zz_0304_base.bin",
    "StockQty": "4",
    "CasesQty": "5",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-TOY-COR0712",
    "Name": "Toyota Corolla 07-12 (2ZR-FE)",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Corolla 1.8L 2ZR-FE Dual VVT-i 2007-2012",
    "CurrentRevision": "Rev 1.1",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Dual VVT-i / Drive-By-Wire / Full CANBUS Instrument Integration",
    "Description": "Computadora PNP para Toyota Corolla 07-12 2ZR",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/toyota_corolla_0712.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/2zr_corolla_base.bin",
    "StockQty": "2",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-TOY-ECHO1NZ",
    "Name": "Toyota Echo 1NZ",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Echo / Yaris 1NZ-FE 1.5L 2000-2005",
    "CurrentRevision": "Rev 1.3",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "5 (Uses same as XRS)",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP 1NZ-FE / VVT-i Control / Idle Valve PWM",
    "Description": "Computadora PNP para Toyota Echo 1NZ",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/toyota_echo_1nz.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/1nz_base.bin",
    "StockQty": "5",
    "CasesQty": "5",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-TOY-TERCEL95",
    "Name": "Toyota Tercel 95 (2 plugs)",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Tercel 1.5L 5E-FE 2-Plug Harness 1995",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "4",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Distributor Ignition / Batch Fire / Idle PWM",
    "Description": "Computadora PNP para Toyota Tercel 95 (2 plugs)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/toyota_tercel_95.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/5efe_95_base.bin",
    "StockQty": "5",
    "CasesQty": "4",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-TOY-TERCEL9699",
    "Name": "Toyota Tercel 96-99 (3 plugs)",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Tercel 1.5L 5E-FE 3-Plug Harness 1996-1999",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "4",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Distributor Ignition / Wasted Spark ready / JJ K-Series PNP compatible",
    "Description": "Computadora PNP para Toyota Tercel 96-99 (3 plugs)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/toyota_tercel_9699.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/5efe_9699_base.bin",
    "StockQty": "10",
    "CasesQty": "4",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-TOY-YARIS0812",
    "Name": "Toyota Yaris 08-12/Corolla XRS 09",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Yaris 1NZ-FE / Corolla XRS 2.4L 2AZ-FE 2008-2012",
    "CurrentRevision": "Rev 1.1",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "0**",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "DBW Throttle / VVT-i / Full CANBUS Dash",
    "Description": "Computadora PNP para Toyota Yaris 08-12 y Corolla XRS 09 2.4L",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/toyota_yaris_0812.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/2az_xrs09_base.bin",
    "StockQty": "3",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-SCION-TC1G",
    "Name": "Scion TC 05-07 (TC 1g)",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Scion tC 2.4L 2AZ-FE 2005-2007",
    "CurrentRevision": "Rev 1.5",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "3",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP 2AZ-FE / DBW / AC Request Jumper",
    "Description": "Computadora PNP para Scion TC 05-07",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/scion_tc1.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/2az_tc1_base.bin",
    "StockQty": "3",
    "CasesQty": "3",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-SCION-TC0811",
    "Name": "Scion TC 2008-11",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Scion tC 2.4L 2AZ-FE 2008-2011 (TC 1.5)",
    "CurrentRevision": "Rev 1.5",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "4",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP 2AZ-FE / Jumper Alignment Update",
    "Description": "Computadora PNP para Scion TC 2008-11",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/scion_tc08.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/2az_tc08_base.bin",
    "StockQty": "4",
    "CasesQty": "4",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-SCION-TC2",
    "Name": "Scion TC 2",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Scion tC 2.5L 2AR-FE Gen 2 2011-2016",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "Core or +$50",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "PNP 2AR-FE / Dual VVT / ETB Jumpers / Cam Ground Fix",
    "Description": "Computadora PNP para Scion TC 2 (4 back panels)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/scion_tc2.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/2ar_tc2_base.bin",
    "StockQty": "20",
    "CasesQty": "4",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-TOY-2GR",
    "Name": "Toyota 2GR Avalon/Xrunner",
    "Category": "plugin",
    "Make": "Toyota",
    "Model": "Avalon / Camry / Tacoma / X-Runner 1GR/2GR 3.5L V6",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "1",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "Dual DBW / Quad VVT / V6 Sequential",
    "Description": "PNP para varias aplicaciones de Toyota1/2GR",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/toyota_2gr.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/2gr_base.bin",
    "StockQty": "17",
    "CasesQty": "1",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-VW-MK3VR6",
    "Name": "VW Jetta/Golf MK3",
    "Category": "plugin",
    "Make": "VW",
    "Model": "Golf / Jetta MK3 2.0L ABA / 2.8L VR6 12V",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "deprecated",
    "MSRP": "$800",
    "JobberPrice": "$640",
    "DealerPrice": "$560",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "60-2 VR Trigger / Wasted Spark / Idle ISV",
    "Description": "Computadora PNP para VW Jetta/Golf MK3 2.0/VR6",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/vw_mk3.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/vr6_mk3_base.bin",
    "StockQty": "1",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-VW-MK418T",
    "Name": "VW Jetta/Golf MK4 1.8T",
    "Category": "plugin",
    "Make": "VW",
    "Model": "Golf / Jetta MK4 1.8T 20V ME7.5 Plug",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "3",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "60-2 VR Trigger / DBW / VVT Vane Control / N75 Boost",
    "Description": "Computadora PNP para VW Jetta/Golf MK4 1.8T 20V",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/vw_mk4_18t.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/18t_mk4_base.bin",
    "StockQty": "5",
    "CasesQty": "3",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-YAM-YXZ1000",
    "Name": "Yamaha YXZ (1000R UTV)",
    "Category": "plugin",
    "Make": "Yamaha",
    "Model": "Yamaha YXZ 1000R 3-Cylinder UTV 2016-2023",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$1,500",
    "JobberPrice": "$1,200",
    "DealerPrice": "$1,050",
    "CoreRequired": "No",
    "ProcessorArch": "Brainboard STM32",
    "Channels": "3-Cylinder Sequential / DBW / Launch Control / Dash CAN",
    "Description": "Computadora Standalone PNP para Yamaha YXZ 1000R",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/yamaha_yxz.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/yxz1000_base.bin",
    "StockQty": "2",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-CHUMA-200EFI",
    "Name": "Chuma 200EFI",
    "Category": "plugin",
    "Make": "Chuma EFI",
    "Model": "Chuma EFI Small Engine / GY6 / Scooter",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$500",
    "JobberPrice": "$400",
    "DealerPrice": "$350",
    "CoreRequired": "No",
    "ProcessorArch": "Micro STM32 Core",
    "Channels": "Single / Twin Cylinder EFI & Ignition",
    "Description": "Computadora Plug and play de Chuma EFI",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/chuma_200efi.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/chuma_base.bin",
    "StockQty": "5",
    "CasesQty": "1",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-CHUMA-MINI",
    "Name": "Chuma 200EFI Mini",
    "Category": "plugin",
    "Make": "Chuma EFI",
    "Model": "Chuma EFI Ultra-Compact Single Plug",
    "CurrentRevision": "Rev 1.1",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$300",
    "JobberPrice": "$240",
    "DealerPrice": "$210",
    "CoreRequired": "30",
    "ProcessorArch": "Micro STM32 Core",
    "Channels": "Ultra-compact single cylinder fuel/spark",
    "Description": "Computadora Plug and play de Chuma EFI (40 ordenadas)",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/chuma_mini.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/chuma_mini_base.bin",
    "StockQty": "40",
    "CasesQty": "1",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-CHUMA-FARRUKO",
    "Name": "Chuma Farruko V1",
    "Category": "plugin",
    "Make": "Chuma EFI",
    "Model": "Chuma Farruko Racing Edition",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$500",
    "JobberPrice": "$400",
    "DealerPrice": "$350",
    "CoreRequired": "No",
    "ProcessorArch": "Micro STM32 Core",
    "Channels": "High RPM single/twin racing ignition and fuel",
    "Description": "Computadora Chuma Farruko V1 para carreras",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/chuma_farruko.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/chuma_farruko_base.bin",
    "StockQty": "4",
    "CasesQty": "0",
    "CreatedAt": "2026-08-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-CHUMA-MAXUMA",
    "Name": "Chuma Maxuma/Itallica/Tank/Supermach",
    "Category": "plugin",
    "Make": "Chuma EFI",
    "Model": "Scooter / Motorcycle Maxuma / Italika / Tank",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$350",
    "JobberPrice": "$280",
    "DealerPrice": "$245",
    "CoreRequired": "No",
    "ProcessorArch": "Micro STM32 Core",
    "Channels": "Plug and play para marcas chinas Maxuma, Italika, Tank y Supermach",
    "Description": "Computadora Plug and Play para motos Chuma/Italika",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/chuma_maxuma.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/chuma_maxuma_base.bin",
    "StockQty": "10",
    "CasesQty": "0",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-CHUMA-2PLUG",
    "Name": "Chuma 2 Plug V1",
    "Category": "plugin",
    "Make": "Chuma EFI",
    "Model": "Chuma Dual Plug Harness EFI",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$450",
    "JobberPrice": "$360",
    "DealerPrice": "$315",
    "CoreRequired": "No",
    "ProcessorArch": "Micro STM32 Core",
    "Channels": "Dual Plug architecture for expanded I/O",
    "Description": "Computadora Chuma EFI versión de 2 plugs",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/chuma_2plug.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/chuma_2plug_base.bin",
    "StockQty": "10",
    "CasesQty": "2",
    "CreatedAt": "2026-03-01T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-PROTO-ECONOLINE",
    "Name": "ProtoRico Econoline / Econolive V3",
    "Category": "protorico",
    "Make": "ProtoRico",
    "Model": "Econoline Modular Multi-Engine V3",
    "CurrentRevision": "Rev 3.0",
    "StatusFlags": "[\"finalized\", \"need_corrections\"]",
    "LifecycleStatus": "active",
    "MSRP": "$650",
    "JobberPrice": "$520",
    "DealerPrice": "$455",
    "CoreRequired": "No",
    "ProcessorArch": "Modular STM32 Carrier",
    "Channels": "Dual VR Conditioner / Configurable Output Transistors",
    "Description": "Plataforma de desarrollo ProtoRico Econoline modular V3",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/protorico_econoline.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/protorico_base.bin",
    "StockQty": "2",
    "CasesQty": "0",
    "CreatedAt": "2026-02-15T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-PROTO-GRUMMAN",
    "Name": "ProtoRico Grumman V1",
    "Category": "protorico",
    "Make": "ProtoRico",
    "Model": "Grumman Industrial / Fleet Engine",
    "CurrentRevision": "Rev 1.0",
    "StatusFlags": "[\"testing_validation\"]",
    "LifecycleStatus": "active",
    "MSRP": "$750",
    "JobberPrice": "$600",
    "DealerPrice": "$525",
    "CoreRequired": "No",
    "ProcessorArch": "Modular STM32 Carrier",
    "Channels": "Heavy Duty Fleet Vehicle I/O",
    "Description": "Plataforma de control ECU industrial ProtoRico Grumman V1",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/protorico_grumman.pdf",
    "BaseTuneUrl": "https://cdn.alphax.com/tunes/grumman_base.bin",
    "StockQty": "2",
    "CasesQty": "0",
    "CreatedAt": "2026-03-01T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-ACC-VRCOND",
    "Name": "AlphaECU VR Conditioner -Neo",
    "Category": "accessory",
    "Make": "Universal",
    "Model": "VR to Digital Hall Converter (1-Channel)",
    "CurrentRevision": "Rev 2.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$49",
    "JobberPrice": "$40",
    "DealerPrice": "$35",
    "CoreRequired": "N/A",
    "ProcessorArch": "MAX9926 High Precision Adaptive VR Chip",
    "Channels": "1-Channel differential VR to 5V Hall converter",
    "Description": "Convertidor de VR a Hall un canal",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/vr_conditioner.pdf",
    "BaseTuneUrl": "",
    "StockQty": "113",
    "CasesQty": "N/A",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-ACC-IGN1CH",
    "Name": "AlphaECU Igniter -Neo --1chan",
    "Category": "accessory",
    "Make": "Universal",
    "Model": "1-Channel Dumb Coil Igniter Driver",
    "CurrentRevision": "Rev 1.2",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$40",
    "JobberPrice": "$30",
    "DealerPrice": "$28",
    "CoreRequired": "N/A",
    "ProcessorArch": "IGBT 20A Ignition Driver",
    "Channels": "1-Channel high energy coil driver",
    "Description": "Igniter de 1 canal, para poder usar bobinas 'dumb'",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/igniter_1ch.pdf",
    "BaseTuneUrl": "",
    "StockQty": "20+",
    "CasesQty": "N/A",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-ACC-IGN4CH",
    "Name": "AlphaECU Igniter -Neo --4chan",
    "Category": "accessory",
    "Make": "Universal",
    "Model": "4-Channel Dumb Coil Igniter Driver",
    "CurrentRevision": "Rev 1.3",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$80",
    "JobberPrice": "$64",
    "DealerPrice": "$60",
    "CoreRequired": "14",
    "ProcessorArch": "Quad IGBT 20A Ignition Module",
    "Channels": "4-Channel high energy coil driver module with heatsink case",
    "Description": "Igniter de 4 canales, para poder usar bobinas 'dumb'",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/igniter_4ch.pdf",
    "BaseTuneUrl": "",
    "StockQty": "40+",
    "CasesQty": "14",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-ACC-IGN8CH",
    "Name": "AlphaECU Igniter -Neo --8chan",
    "Category": "accessory",
    "Make": "Universal",
    "Model": "8-Channel Dumb Coil Igniter Driver (V8)",
    "CurrentRevision": "Rev 1.1",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$120",
    "JobberPrice": "$100",
    "DealerPrice": "$80",
    "CoreRequired": "5",
    "ProcessorArch": "Octal IGBT 20A Ignition Module",
    "Channels": "8-Channel high energy coil driver module for V8 engines",
    "Description": "Igniter de 8 canales, para poder usar bobinas 'dumb'",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/igniter_8ch.pdf",
    "BaseTuneUrl": "",
    "StockQty": "5",
    "CasesQty": "5",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-ACC-WEYBAN",
    "Name": "AlphaX Wideband WBO2 -Weyban",
    "Category": "accessory",
    "Make": "Universal",
    "Model": "Bosch LSU 4.9 Controller Module",
    "CurrentRevision": "Rev 1.4",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$80",
    "JobberPrice": "$60",
    "DealerPrice": "$60",
    "CoreRequired": "6",
    "ProcessorArch": "Bosch CJ125 / LSU 4.9 Precision Controller",
    "Channels": "Analog 0-5V Linear AFR Output + CANBUS Digital Stream",
    "Description": "Modulo para usar widebands con un sensor Bosch LSU 4.9",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/weyban_wideband.pdf",
    "BaseTuneUrl": "",
    "StockQty": "33",
    "CasesQty": "6",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  },
  {
    "ProductID": "PROD-ACC-RELAYPANEL",
    "Name": "AlphaX Relay Panel (RelayPenal)",
    "Category": "accessory",
    "Make": "Universal",
    "Model": "Dual 70A + Quad 20A Power Distribution",
    "CurrentRevision": "Rev 2.0",
    "StatusFlags": "[\"finalized\"]",
    "LifecycleStatus": "active",
    "MSRP": "$69",
    "JobberPrice": "$55",
    "DealerPrice": "$50",
    "CoreRequired": "N/A",
    "ProcessorArch": "Heavy-Duty Automotive Relay Board",
    "Channels": "2x 70A Relays + 4x 20A Relays + Fuse Block",
    "Description": "Panel de Relays, con dos relays de 70A, y 4 relays de 20a, ademas de fusibles y main relay",
    "PinoutUrl": "https://cdn.alphax.com/pinouts/relay_panel.pdf",
    "BaseTuneUrl": "",
    "StockQty": "25",
    "CasesQty": "N/A",
    "CreatedAt": "2026-01-10T10:00:00Z",
    "UpdatedAt": "2026-08-10T14:00:00Z"
  }
];

  const plugins = ECU_DATABASE.filter(item => item.Category && item.Category.toLowerCase() === 'plugin');
  const universals = ECU_DATABASE.filter(item => item.Category && item.Category.toLowerCase() === 'universal');

  // Complete Bilingual Localization Dictionary
  const I18N = {
  "en": {
    "brandBadge": "AlphaX Engine Management",
    "mainTitle": "ECU Choice Helper",
    "mainSubtitle": "Find the exact Engine Management System tailored to your vehicle, wiring architecture, cylinder count, and performance goals.",
    "langLabel": "Language:",
    "crumbHome": "Home",
    "crumbSituation": "Choose Situation",
    "crumbPnp": "Plug & Play (Factory Harness)",
    "crumbRewire": "Custom Engine Rewiring",
    "crumbSwap": "Engine Swap Project",
    "crumbBudget": "Budget / Economical Options",
    "btnRestart": "Change Situation",
    "landingBannerTitle": "What best describes your current project?",
    "landingBannerDesc": "Select the situation that matches your vehicle setup to receive instant recommendations, compatibility checks, and buying advice.",
    "sit1Title": "1. Direct Factory Plug-in",
    "sit1Quote": "\"I have a car that I want to change the ECU on, but I want to connect directly to the factory harness.\"",
    "sit1Desc": "No cutting or custom wiring required. Check our database of 63+ direct Plug-and-Play (PNP) ECUs for Honda, BMW, Ford, Toyota, Mitsubishi, Mazda, Nissan, and more.",
    "sit1Cta": "Check PNP Availability",
    "sit2Title": "2. New Engine Harness / Rewire",
    "sit2Quote": "\"I have a car that I'm rewiring and making a new engine harness.\"",
    "sit2Desc": "Building a clean standalone engine harness from scratch. Match the right universal ECU based on your cylinder count, ignition method, and auxiliary requirements.",
    "sit2Cta": "Configure Universal Standalone",
    "sit3Title": "3. Engine Swap Project",
    "sit3Quote": "\"I'm swapping the engine on my car to a new one.\"",
    "sit3Desc": "Dropping a K-Series, LS, 2JZ, SR20, or Coyote into a custom chassis. Select the right standalone architecture to control your swap, cluster, and sensors seamlessly.",
    "sit3Cta": "Select Engine Swap ECU",
    "sit4Title": "4. Economical / Budget Builds",
    "sit4Quote": "\"I'm strapped for cash and I'm looking for the most economical solution available.\"",
    "sit4Desc": "Compare our entry-level champions: Iron ($349), Copper ($449), and Bronze ($499). Detailed breakdown of wasted spark, distributor, and connector features.",
    "sit4Cta": "Compare Budget Options",
    "pnpStepTitle": "Select Your Vehicle & Factory Engine",
    "pnpStepDesc": "Search or choose your vehicle manufacturer and model below to check availability for your factory wiring harness.",
    "pnpSearchPlaceholder": "Quick Search: Type your car or engine (e.g. 'Civic 8th', 'Miata', 'Mustang Coyote', '350Z', 'Corolla 2ZZ')...",
    "pnpMakeLabel": "1. Vehicle Brand / Make",
    "pnpMakeDefault": "-- Select Vehicle Brand / Make --",
    "pnpModelLabel": "2. Model / Engine / Generation",
    "pnpModelDefault": "-- Select Model / Engine --",
    "pnpNotFoundTitle": "No direct Plug & Play ECU match found for",
    "pnpNotFoundDesc": "Don't worry! If we don't have a direct plug-and-play adapter for your specific chassis, you can easily wire one of our Universal Standalone ECUs (Silver, Gold, Copper, Bronze) using a custom or patch harness.",
    "pnpNotFoundBtn": "Explore Universal Standalones",
    "pnpFallbackTitle": "Don't see your specific car or engine listed?",
    "pnpFallbackDesc": "We can still run your engine! You can use one of our universal standalones (Silver, Gold, Copper, Bronze) with a custom wire-in harness or patch adapter.",
    "pnpBadgeMatch": "✓ Direct Plug & Play ECU Available",
    "btnBuyNow": "Buy Now on AlphaX Store",
    "rewireStepTitle": "Custom Engine Harness & Standalone Selector",
    "rewireStepDesc": "When building a new engine harness from scratch, choose your cylinder count and powertrain requirements below:",
    "rewireQuestion": "How many cylinders does your car / engine have?",
    "swapStepTitle": "Engine Swap Project Advisor",
    "swapStepDesc": "Swapping an engine into a new chassis requires reliable standalone control, sensor adaptation, and cluster integration:",
    "swapQuestion": "What engine configuration are you swapping in?",
    "cyl4Title": "4 Cylinders",
    "cyl4Desc": "Inline-4 / Flat-4 (K-Series, 4G63, SR20, BP, EJ, etc.)",
    "cyl68Title": "6 or 8 Cylinders (V6 / V8)",
    "cyl68Desc": "V6, Inline-6, or V8 (LS, Coyote, 2JZ, VQ35, Barra, Small Block)",
    "cylAdvTitle": "Advanced Setup / High I/O",
    "cylAdvDesc": "Turbos, Nitrous, Methanol, Multiple Temp Inputs, Dual DBW, 10/12-Cyl",
    "recBadgePrefix": "✓ Recommended for your",
    "recBadgeSuffix": "Build",
    "labelChannelCap": "Channel Capacity",
    "labelEngineArch": "Engine Architecture",
    "labelProcessor": "Processor Core",
    "labelAvailability": "Availability",
    "inStockText": "In Stock & Ready to Ship",
    "builtToOrderText": "Available / Built to Order",
    "msrpLabel": "MSRP",
    "budgetStepTitle": "Budget Champions: Iron vs. Copper vs. Bronze",
    "budgetStepDesc": "Looking for the most cost-effective solution without compromising performance? Review the key hardware differences and capabilities below to select the right fit for your budget:",
    "budgetQuickMatcher": "Quick Budget Engine Matcher:",
    "budgetMatchIronTitle": "4-Cyl Wasted Spark / Distributor",
    "budgetMatchIronDesc": "Most affordable standalone on the market ($349)",
    "budgetMatchCopperTitle": "4-Cyl Sequential OR up to V8",
    "budgetMatchCopperDesc": "4 full ignition & injection outputs ($449)",
    "budgetMatchBronzeTitle": "Superseal 24-Pin + Dual-Map Switch",
    "budgetMatchBronzeDesc": "6 Inj / 4 Ign + Internal Ground-Drive Jumpers ($499)",
    "ironBadge": "Ultra-Budget",
    "ironCrucial": "⚠️ <strong>Output Architecture Reminder:</strong> Iron has <strong>2 outputs</strong>. Therefore, 4-cylinder engines run in <strong>wasted spark</strong> (and semi-sequential/batch injection). Anything larger than 4 cylinders (6 or 8 cylinders) <strong>must be distributed using a mechanical distributor</strong>.",
    "ironSpecs1": "2 Injector / 2 Ignition",
    "ironSpecs2": "Molex Connectors",
    "ironSpecs3": "4-Cyl (Wasted Spark) / V8 (Distributor)",
    "ironSpecs4": "VR + Hall Crank/Cam Sensors",
    "ironSpecs5": "Budget 4-cyl turbo, classic carbureted-to-EFI conversions, piggybacks",
    "copperBadge": "4-Cyl Sequential",
    "copperCrucial": "✅ <strong>Expanded 4-Channel Control:</strong> Copper features <strong>4 full cylinder support</strong> (4 injector & 4 ignition outputs), enabling true sequential fuel & spark on 4-cylinders and supporting up to <strong>V8 sequential fuel</strong> with distributor or wasted spark coil pairs.",
    "copperSpecs1": "4 Injector / 4 Ignition",
    "copperSpecs2": "Molex Connectors",
    "copperSpecs3": "4-Cyl Full Sequential / up to V8",
    "copperSpecs4": "Boost Control Solenoid, Launch Control, VR/Hall",
    "copperSpecs5": "Full sequential 4-cylinder street/drag builds, budget V8 swaps",
    "bronzeBadge": "Rugged Motorsport",
    "bronzeCrucial": "🌟 <strong>Exclusive Internal Jumper Feature:</strong> Bronze features automotive <strong>Superseal 24-pin connectors</strong>, up to <strong>6 injector & 4 ignition outputs</strong>. <em>Only on Bronze can the ignition outputs be configured to drive directly to ground with an internal jumper!</em>",
    "bronzeSpecs1": "Up to 6 Injector / 4 Ignition",
    "bronzeSpecs2": "Automotive Superseal 24-Pin (Waterproof)",
    "bronzeSpecs3": "Internal Jumper Configurable (5V Logic or Ground-Drive)",
    "bronzeSpecs4": "Physical Dual-Map Switch, Launch, Boost Control",
    "bronzeSpecs5": "Rally, harsh environments, 6-cyl semi-sequential, 4-cyl sequential with dual maps",
    "tableColFuelSpark": "Fuel / Spark Outputs",
    "tableColConnector": "Connector Type",
    "tableColCylinder": "Cylinder Support",
    "tableColFeatures": "Key Features / Drivers",
    "tableColUseCase": "Typical Use Case"
  },
  "es": {
    "brandBadge": "AlphaX Gestión de Motor",
    "mainTitle": "Asistente de Selección de ECU",
    "mainSubtitle": "Encuentra el sistema de inyección electrónica programable ideal para tu vehículo, tipo de cableado, número de cilindros y metas de potencia.",
    "langLabel": "Idioma:",
    "crumbHome": "Inicio",
    "crumbSituation": "Elegir Situación",
    "crumbPnp": "Plug & Play (Arnés Original)",
    "crumbRewire": "Realambrado / Nuevo Arnés",
    "crumbSwap": "Proyecto de Swap de Motor",
    "crumbBudget": "Opciones Económicas / Presupuesto",
    "btnRestart": "Cambiar Situación",
    "landingBannerTitle": "¿Qué situación describe mejor tu proyecto actual?",
    "landingBannerDesc": "Selecciona la opción correspondiente para recibir recomendaciones inmediatas, verificación de compatibilidad y enlaces directos de compra.",
    "sit1Title": "1. Conexión Directa de Fábrica (PNP)",
    "sit1Quote": "\"Tengo un auto al que quiero cambiarle la ECU, pero quiero conectarla directamente al arnés original de fábrica.\"",
    "sit1Desc": "Sin cortes ni adaptaciones complejas. Consulta nuestra base de datos con más de 63 ECUs Plug-and-Play para Honda, BMW, Ford, Toyota, Mitsubishi, Mazda, Nissan y más.",
    "sit1Cta": "Consultar Disponibilidad PNP",
    "sit2Title": "2. Realambrado / Fabricación de Arnés",
    "sit2Quote": "\"Tengo un auto al que le estoy rehaciendo el cableado y fabricando un nuevo arnés de motor.\"",
    "sit2Desc": "Construyendo un arnés independiente desde cero. Elige la ECU universal exacta según el número de cilindros, tipo de encendido y entradas/salidas requeridas.",
    "sit2Cta": "Configurar ECU Universal",
    "sit3Title": "3. Swap de Motor (Adaptación)",
    "sit3Quote": "\"Le estoy haciendo un swap de motor a mi auto por otro nuevo.\"",
    "sit3Desc": "Instalando un motor K-Series, LS, 2JZ, SR20 o Coyote en otro chasis. Selecciona la arquitectura adecuada para controlar el motor, sensores y tacómetro sin fallas.",
    "sit3Cta": "Seleccionar ECU para Swap",
    "sit4Title": "4. Presupuesto Ajustado / Económica",
    "sit4Quote": "\"Tengo un presupuesto ajustado y busco la solución más económica disponible.\"",
    "sit4Desc": "Compara nuestras opciones de entrada: Iron ($349), Copper ($449) y Bronze ($499). Conoce las diferencias en chispa perdida, distribuidor y conectores sellados.",
    "sit4Cta": "Comparar Opciones Económicas",
    "pnpStepTitle": "Selecciona tu Vehículo y Motor de Fábrica",
    "pnpStepDesc": "Busca o selecciona el fabricante y modelo de tu vehículo para verificar si tenemos una ECU de conexión directa Plug and Play.",
    "pnpSearchPlaceholder": "Búsqueda rápida: Escribe tu auto o motor (ej. 'Civic 8th', 'Miata', 'Mustang Coyote', '350Z', 'Corolla 2ZZ')...",
    "pnpMakeLabel": "1. Marca del Vehículo",
    "pnpMakeDefault": "-- Seleccionar Marca --",
    "pnpModelLabel": "2. Modelo / Motor / Generación",
    "pnpModelDefault": "-- Seleccionar Modelo / Motor --",
    "pnpNotFoundTitle": "No se encontró ECU Plug & Play directa para",
    "pnpNotFoundDesc": "¡No te preocupes! Si no disponemos de un arnés directo para tu chasis, puedes instalar fácilmente una de nuestras ECUs Universales (Silver, Gold, Copper, Bronze) mediante un arnés universal o puente.",
    "pnpNotFoundBtn": "Ver Opciones Universales",
    "pnpFallbackTitle": "¿No ves tu modelo o motor específico en la lista?",
    "pnpFallbackDesc": "¡Podemos hacer funcionar tu motor! Puedes utilizar una de nuestras ECUs universales (Silver, Gold, Copper, Bronze) con cableado universal.",
    "pnpBadgeMatch": "✓ ECU Plug & Play Directa Disponible",
    "btnBuyNow": "Comprar en Tienda Oficial AlphaX",
    "rewireStepTitle": "Selector de ECU Universal para Realambrado",
    "rewireStepDesc": "Al fabricar un nuevo arnés desde cero, selecciona el número de cilindros y los requisitos de tu motor:",
    "rewireQuestion": "¿Cuántos cilindros tiene tu vehículo / motor?",
    "swapStepTitle": "Asesor de ECU para Proyectos de Swap",
    "swapStepDesc": "Adaptar un motor en un nuevo chasis requiere control independiente confiable, integración de sensores y señal para el clúster:",
    "swapQuestion": "¿Qué configuración de motor estás instalando (Swap)?",
    "cyl4Title": "4 Cilindros",
    "cyl4Desc": "4 en línea / Boxer 4 (K-Series, 4G63, SR20, BP, EJ, etc.)",
    "cyl68Title": "6 u 8 Cilindros (V6 / V8)",
    "cyl68Desc": "V6, 6 en línea o V8 (LS, Coyote, 2JZ, VQ35, Barra, Small Block)",
    "cylAdvTitle": "Setup Avanzado / Alto I/O",
    "cylAdvDesc": "Turbos, Nitro, Metanol, Múltiples Sensores de Temp, Dual DBW, 10/12-Cil",
    "recBadgePrefix": "✓ Recomendada para tu Proyecto de",
    "recBadgeSuffix": "",
    "labelChannelCap": "Capacidad de Canales",
    "labelEngineArch": "Arquitectura de Motor",
    "labelProcessor": "Procesador Principal",
    "labelAvailability": "Disponibilidad",
    "inStockText": "En Stock / Envío Inmediato",
    "builtToOrderText": "Disponible / Fabricación a la Orden",
    "msrpLabel": "Precio Sugerido (MSRP)",
    "budgetStepTitle": "Opciones Económicas: Iron vs. Copper vs. Bronze",
    "budgetStepDesc": "¿Buscas la solución más accesible sin comprometer el rendimiento? Revisa las diferencias técnicas clave y capacidades de hardware para elegir la ideal:",
    "budgetQuickMatcher": "Filtro Rápido por Tipo de Motor:",
    "budgetMatchIronTitle": "4-Cil Chispa Perdida o Distribuidor",
    "budgetMatchIronDesc": "La ECU programable más económica del mercado ($349)",
    "budgetMatchCopperTitle": "4-Cil Secuencial o hasta V8",
    "budgetMatchCopperDesc": "4 salidas completas de inyección e ignición ($449)",
    "budgetMatchBronzeTitle": "Superseal 24-Pin + Switch Doble Mapa",
    "budgetMatchBronzeDesc": "6 Inj / 4 Ign + Jumpers Internos para Excitar a Tierra ($499)",
    "ironBadge": "Ultra-Económica",
    "ironCrucial": "⚠️ <strong>Regla Fundamental de Salidas:</strong> La Iron cuenta con <strong>2 salidas</strong>. Por lo tanto, en motores de 4 cilindros trabaja en <strong>chispa perdida</strong> (wasted spark) e inyección semi-secuencial. Cualquier motor de más de 4 cilindros (6 u 8 cilindros) <strong>requiere obligatoriamente distribuidor mecánico</strong>.",
    "ironSpecs1": "2 Inyectores / 2 Ignición",
    "ironSpecs2": "Conectores Molex",
    "ironSpecs3": "4-Cyl (Chispa Perdida) / V8 (Distribuidor)",
    "ironSpecs4": "Sensores VR + Hall de Cigüeñal/Levas",
    "ironSpecs5": "4-cil turbo económico, conversiones de carburador a inyección, piggyback",
    "copperBadge": "4-Cil Secuencial",
    "copperCrucial": "✅ <strong>Control Completo de 4 Canales:</strong> La Copper posee <strong>4 salidas completas de inyección y 4 de ignición</strong>, permitiendo inyección y chispa totalmente secuencial en 4 cilindros, y soportando hasta motores <strong>V8</strong> (inyección secuencial con distribuidor o bobinas en pares).",
    "copperSpecs1": "4 Inyectores / 4 Ignición",
    "copperSpecs2": "Conectores Molex",
    "copperSpecs3": "4-Cil Secuencial Completo / hasta V8",
    "copperSpecs4": "Solenoide de Boost, Control de Largada (Launch), VR/Hall",
    "copperSpecs5": "4-cilindros secuencial para calle/pista, swaps V8 económicos",
    "bronzeBadge": "Sellado Automotriz",
    "bronzeCrucial": "🌟 <strong>Característica Exclusiva de Hardware:</strong> La Bronze incorpora <strong>conectores automotrices Superseal de 24 pines</strong> sellados, hasta <strong>6 salidas de inyección y 4 de ignición</strong>. <em>¡Solo en la Bronze las salidas de ignición pueden configurarse internamente mediante un jumper para excitar directamente a tierra (drive to ground)!</em>",
    "bronzeSpecs1": "Hasta 6 Inyectores / 4 Ignición",
    "bronzeSpecs2": "Conector Superseal 24 Pines (Impermeable)",
    "bronzeSpecs3": "Salidas de Ignición Configurables a Tierra (Jumper)",
    "bronzeSpecs4": "Switch Físico de Doble Mapa, Launch, Control de Boost",
    "bronzeSpecs5": "Rally, ambientes severos, 6-cil semi-secuencial, 4-cil secuencial con 2 mapas",
    "tableColFuelSpark": "Salidas Iny / Ign",
    "tableColConnector": "Tipo de Conector",
    "tableColCylinder": "Capacidad Cilindros",
    "tableColFeatures": "Drivers / Extras",
    "tableColUseCase": "Uso Recomendado"
  }
};

  // State
  let currentLang = 'en';
  let dom = {};
  let state = {
    currentSituation: null,
    selectedMake: '',
    selectedModelId: '',
    selectedCylinders: null,
    searchQuery: ''
  };

  function init() {
    cacheDom();
    bindEvents();
    populateMakeDropdown();
    applyLanguage(currentLang);
    showView('landing');
  }

  function cacheDom() {
    dom = {
      wrapper: document.getElementById('ax-ecu-helper'),
      // Language toggles
      btnLangEn: document.getElementById('ax-btn-lang-en'),
      btnLangEs: document.getElementById('ax-btn-lang-es'),

      // Views
      viewLanding: document.getElementById('ax-view-landing'),
      viewPnp: document.getElementById('ax-view-pnp'),
      viewRewire: document.getElementById('ax-view-rewire'),
      viewSwap: document.getElementById('ax-view-swap'),
      viewBudget: document.getElementById('ax-view-budget'),
      
      // Breadcrumbs
      breadcrumbs: document.getElementById('ax-breadcrumbs'),
      crumbCurrent: document.getElementById('ax-crumb-current'),
      btnRestart: document.getElementById('ax-btn-restart'),
      
      // Situation Cards
      cards: document.querySelectorAll('.ax-situation-card'),
      
      // PNP Selectors
      selectMake: document.getElementById('ax-pnp-make'),
      selectModel: document.getElementById('ax-pnp-model'),
      pnpModelGroup: document.getElementById('ax-pnp-model-group'),
      pnpSearch: document.getElementById('ax-pnp-search'),
      pnpResultContainer: document.getElementById('ax-pnp-result'),
      
      // Choice Buttons
      rewireButtons: document.querySelectorAll('#ax-view-rewire .ax-choice-option-btn'),
      rewireResultContainer: document.getElementById('ax-rewire-result'),
      
      swapButtons: document.querySelectorAll('#ax-view-swap .ax-choice-option-btn'),
      swapResultContainer: document.getElementById('ax-swap-result'),
      
      // Budget Buttons & Cards
      budgetFilterButtons: document.querySelectorAll('#ax-view-budget .ax-choice-option-btn'),
      budgetCards: document.querySelectorAll('.ax-budget-card')
    };
  }

  function bindEvents() {
    // Language Switcher direct click
    if (dom.btnLangEn) {
      dom.btnLangEn.addEventListener('click', function (e) {
        e.preventDefault();
        setLanguage('en');
      });
    }
    if (dom.btnLangEs) {
      dom.btnLangEs.addEventListener('click', function (e) {
        e.preventDefault();
        setLanguage('es');
      });
    }

    // Restart / Start Over
    if (dom.btnRestart) {
      dom.btnRestart.addEventListener('click', function (e) {
        e.preventDefault();
        resetState();
        showView('landing');
      });
    }

    // Situation Card Clicks
    if (dom.cards) {
      dom.cards.forEach(function (card) {
        card.addEventListener('click', function () {
          const situation = card.getAttribute('data-situation');
          selectSituation(situation);
        });
      });
    }

    // PNP Make change
    if (dom.selectMake) {
      dom.selectMake.addEventListener('change', function (e) {
        state.selectedMake = e.target.value;
        populateModelDropdown(state.selectedMake);
        if (dom.pnpResultContainer) dom.pnpResultContainer.innerHTML = '';
      });
    }

    // PNP Model change
    if (dom.selectModel) {
      dom.selectModel.addEventListener('change', function (e) {
        state.selectedModelId = e.target.value;
        if (state.selectedModelId) {
          renderPnpResult(state.selectedModelId);
        } else if (dom.pnpResultContainer) {
          dom.pnpResultContainer.innerHTML = '';
        }
      });
    }

    // PNP Search input
    if (dom.pnpSearch) {
      dom.pnpSearch.addEventListener('input', function (e) {
        const query = e.target.value.trim().toLowerCase();
        state.searchQuery = query;
        if (query.length > 1) {
          handlePnpSearch(query);
        } else if (query.length === 0 && state.selectedModelId) {
          renderPnpResult(state.selectedModelId);
        } else if (query.length === 0 && dom.pnpResultContainer) {
          dom.pnpResultContainer.innerHTML = '';
        }
      });
    }

    // Rewire Options
    if (dom.rewireButtons) {
      dom.rewireButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          dom.rewireButtons.forEach(function (b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          const type = btn.getAttribute('data-cylinders');
          state.selectedCylinders = type;
          renderUniversalRecommendation(type, dom.rewireResultContainer, 'rewire');
        });
      });
    }

    // Swap Options
    if (dom.swapButtons) {
      dom.swapButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          dom.swapButtons.forEach(function (b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          const type = btn.getAttribute('data-cylinders');
          state.selectedCylinders = type;
          renderUniversalRecommendation(type, dom.swapResultContainer, 'swap');
        });
      });
    }

    // Budget Engine Filter Options
    if (dom.budgetFilterButtons) {
      dom.budgetFilterButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          dom.budgetFilterButtons.forEach(function (b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          const rec = btn.getAttribute('data-budget-rec');
          highlightBudgetCard(rec);
        });
      });
    }
  }

  function setLanguage(lang) {
    currentLang = lang;
    if (dom.btnLangEn && dom.btnLangEs) {
      if (lang === 'en') {
        dom.btnLangEn.classList.add('active');
        dom.btnLangEs.classList.remove('active');
      } else {
        dom.btnLangEs.classList.add('active');
        dom.btnLangEn.classList.remove('active');
      }
    }
    applyLanguage(lang);

    // Refresh dropdowns with new language defaults
    populateMakeDropdown();
    if (state.selectedMake) {
      populateModelDropdown(state.selectedMake);
      if (dom.selectModel) dom.selectModel.value = state.selectedModelId;
    }

    // Re-render active results if present
    if (state.currentSituation === 'pnp' && state.selectedModelId) {
      renderPnpResult(state.selectedModelId);
    } else if (state.currentSituation === 'rewire' && state.selectedCylinders) {
      renderUniversalRecommendation(state.selectedCylinders, dom.rewireResultContainer, 'rewire');
    } else if (state.currentSituation === 'swap' && state.selectedCylinders) {
      renderUniversalRecommendation(state.selectedCylinders, dom.swapResultContainer, 'swap');
    }
  }

  function applyLanguage(lang) {
    const t = I18N[lang] || I18N.en;

    // Elements with data-i18n
    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      const key = el.getAttribute('data-i18n');
      if (t[key]) {
        el.innerHTML = t[key];
      }
    });

    // Inputs with data-i18n-placeholder
    document.querySelectorAll('[data-i18n-placeholder]').forEach(function (el) {
      const key = el.getAttribute('data-i18n-placeholder');
      if (t[key]) {
        el.setAttribute('placeholder', t[key]);
      }
    });

    // Update current breadcrumb text
    updateBreadcrumbText();
  }

  function updateBreadcrumbText() {
    const t = I18N[currentLang];
    if (!dom.crumbCurrent) return;

    if (state.currentSituation === 'pnp') {
      dom.crumbCurrent.textContent = t.crumbPnp;
    } else if (state.currentSituation === 'rewire') {
      dom.crumbCurrent.textContent = t.crumbRewire;
    } else if (state.currentSituation === 'swap') {
      dom.crumbCurrent.textContent = t.crumbSwap;
    } else if (state.currentSituation === 'budget') {
      dom.crumbCurrent.textContent = t.crumbBudget;
    } else {
      dom.crumbCurrent.textContent = t.crumbSituation;
    }
  }

  function resetState() {
    state.currentSituation = null;
    state.selectedMake = '';
    state.selectedModelId = '';
    state.selectedCylinders = null;
    state.searchQuery = '';

    if (dom.selectMake) dom.selectMake.value = '';
    if (dom.selectModel) {
      const t = I18N[currentLang];
      dom.selectModel.innerHTML = '<option value="">' + t.pnpModelDefault + '</option>';
      if (dom.pnpModelGroup) dom.pnpModelGroup.style.display = 'none';
    }
    if (dom.pnpSearch) dom.pnpSearch.value = '';
    if (dom.pnpResultContainer) dom.pnpResultContainer.innerHTML = '';
    if (dom.rewireResultContainer) dom.rewireResultContainer.innerHTML = '';
    if (dom.swapResultContainer) dom.swapResultContainer.innerHTML = '';
    if (dom.rewireButtons) dom.rewireButtons.forEach(function (b) { b.classList.remove('selected'); });
    if (dom.swapButtons) dom.swapButtons.forEach(function (b) { b.classList.remove('selected'); });
    if (dom.budgetFilterButtons) dom.budgetFilterButtons.forEach(function (b) { b.classList.remove('selected'); });
    if (dom.budgetCards) {
      dom.budgetCards.forEach(function (c) {
        c.style.borderColor = '';
        c.style.boxShadow = '';
        c.style.transform = '';
      });
    }
  }

  function showView(viewName) {
    const allViews = [dom.viewLanding, dom.viewPnp, dom.viewRewire, dom.viewSwap, dom.viewBudget];
    allViews.forEach(function (v) {
      if (v) v.classList.remove('active');
    });

    if (viewName === 'landing' && dom.viewLanding) {
      dom.viewLanding.classList.add('active');
      if (dom.btnRestart) dom.btnRestart.style.display = 'none';
    } else if (viewName === 'pnp' && dom.viewPnp) {
      dom.viewPnp.classList.add('active');
      if (dom.btnRestart) dom.btnRestart.style.display = 'inline-flex';
    } else if (viewName === 'rewire' && dom.viewRewire) {
      dom.viewRewire.classList.add('active');
      if (dom.btnRestart) dom.btnRestart.style.display = 'inline-flex';
    } else if (viewName === 'swap' && dom.viewSwap) {
      dom.viewSwap.classList.add('active');
      if (dom.btnRestart) dom.btnRestart.style.display = 'inline-flex';
    } else if (viewName === 'budget' && dom.viewBudget) {
      dom.viewBudget.classList.add('active');
      if (dom.btnRestart) dom.btnRestart.style.display = 'inline-flex';
    }

    updateBreadcrumbText();

    if (dom.wrapper) {
      window.scrollTo({ top: dom.wrapper.offsetTop - 20, behavior: 'smooth' });
    }
  }

  function selectSituation(situation) {
    state.currentSituation = situation;
    if (situation === 'pnp') {
      showView('pnp');
    } else if (situation === 'rewire') {
      showView('rewire');
    } else if (situation === 'swap') {
      showView('swap');
    } else if (situation === 'budget') {
      showView('budget');
    }
  }

  function populateMakeDropdown() {
    if (!dom.selectMake) return;
    const t = I18N[currentLang];
    const prevVal = dom.selectMake.value;
    const makes = [...new Set(plugins.map(function (p) { return p.Make; }).filter(Boolean))].sort();
    
    let html = '<option value="">' + t.pnpMakeDefault + '</option>';
    makes.forEach(function (make) {
      const count = plugins.filter(function (p) { return p.Make === make; }).length;
      html += '<option value="' + make + '">' + make + ' (' + count + ' models)</option>';
    });
    dom.selectMake.innerHTML = html;
    if (prevVal) dom.selectMake.value = prevVal;
  }

  function populateModelDropdown(make) {
    if (!dom.selectModel || !dom.pnpModelGroup) return;
    const t = I18N[currentLang];
    if (!make) {
      dom.pnpModelGroup.style.display = 'none';
      return;
    }

    const filtered = plugins.filter(function (p) { return p.Make === make; });
    let html = '<option value="">' + t.pnpModelDefault + '</option>';
    filtered.forEach(function (p) {
      html += '<option value="' + p.ProductID + '">' + p.Name + ' - ' + p.Model + '</option>';
    });

    dom.selectModel.innerHTML = html;
    dom.pnpModelGroup.style.display = 'block';
  }

  function handlePnpSearch(query) {
    const t = I18N[currentLang];
    const matches = plugins.filter(function (p) {
      const text = (p.Name + ' ' + (p.Make || '') + ' ' + (p.Model || '') + ' ' + (p.Channels || '') + ' ' + (p.Description || '')).toLowerCase();
      return text.includes(query);
    });

    if (matches.length === 0) {
      dom.pnpResultContainer.innerHTML = `
        <div class="ax-fallback-box">
          <div style="font-size: 2rem; margin-bottom: 8px;">🔍</div>
          <h3>${t.pnpNotFoundTitle} "${query}"</h3>
          <p>${t.pnpNotFoundDesc}</p>
          <div class="ax-actions-row" style="justify-content: center;">
            <button class="ax-btn ax-btn-primary" onclick="window.axChoiceHelper.selectSituation('rewire')">
              ${t.pnpNotFoundBtn} &rarr;
            </button>
          </div>
        </div>
      `;
      return;
    }

    if (matches.length === 1) {
      renderPnpResult(matches[0].ProductID);
    } else {
      let html = '<div style="margin-bottom: 16px; color: var(--ax-text-muted); font-size: 0.9rem;">' + 
        (currentLang === 'es' ? 'Se encontraron ' + matches.length + ' ECUs plug-in:' : 'Found ' + matches.length + ' matching plug-in ECUs:') + 
        '</div><div style="display: flex; flex-direction: column; gap: 16px;">';
      matches.forEach(function (item) {
        html += generateProductCardHtml(item, 'pnp');
      });
      html += '</div>';
      dom.pnpResultContainer.innerHTML = html;
    }
  }

  function renderPnpResult(productId) {
    const product = plugins.find(function (p) { return p.ProductID === productId; });
    if (!product || !dom.pnpResultContainer) return;
    dom.pnpResultContainer.innerHTML = generateProductCardHtml(product, 'pnp');
  }

  function renderUniversalRecommendation(cylinderChoice, targetContainer, context) {
    if (!targetContainer) return;
    const t = I18N[currentLang];
    let recProduct = null;
    let descEn = '';
    let descEs = '';
    let contextNoteEn = '';
    let contextNoteEs = '';
    let storeHandle = '';

    if (cylinderChoice === '4cyl') {
      recProduct = universals.find(function (u) { return u.ProductID === 'PROD-UNI-SILVER'; }) || {
        Name: 'AlphaECU Silver',
        MSRP: '$599',
        ProcessorArch: 'STM32 168MHz + LSU4.9 Driver',
        Channels: '6 Injector / 6 Ignition / Built-in Wideband LSU 4.9'
      };
      storeHandle = 'alphaecu-silver';
      descEn = 'Ideal for 4-cylinder high-performance builds. Features 6 injection and 6 ignition outputs, allowing full sequential control plus extra outputs for boost control, VVT, tachometer, and electric cooling fans. Includes an integrated Bosch LSU 4.9 Wideband controller directly on the board.';
      descEs = 'Ideal para proyectos de 4 cilindros de alto rendimiento. Cuenta con 6 salidas de inyección y 6 de ignición (secuencial completo + 2 salidas para solenoide de boost, VVT o tacómetro). Incorpora un controlador de Wideband Bosch LSU 4.9 integrado directamente en la placa.';
      contextNoteEn = context === 'swap' 
        ? '💡 <strong>Swap Note:</strong> Silver includes an onboard Bosch LSU 4.9 controller so you do not need to buy or wire an external wideband gauge/controller box!'
        : '💡 <strong>Wiring Tip:</strong> 6 fuel and 6 spark channels allow full sequential operation on 4-cylinder engines with 2 spare high-current outputs for boost solenoids, VVT, or shift lights.';
      contextNoteEs = context === 'swap'
        ? '💡 <strong>Nota para Swap:</strong> La Silver incluye controlador Wideband LSU 4.9 integrado en la ECU, eliminando la necesidad de comprar o instalar relojes/controladores externos en tu motor swapeado.'
        : '💡 <strong>Consejo de Realambrado:</strong> 6 canales de combustible e ignición permiten control secuencial en 4 cilindros y te dejan 2 salidas de potencia libres para boost, VVT o luz de cambio.';
    } else if (cylinderChoice === 'v6v8') {
      recProduct = universals.find(function (u) { return u.ProductID === 'PROD-UNI-GOLD'; }) || {
        Name: 'AlphaECU Gold',
        MSRP: '$999',
        ProcessorArch: 'STM32 168MHz BlackPill',
        Channels: '8 Injector / 8 Ignition / Dual Wideband / CANBUS'
      };
      storeHandle = 'alphaecu-gold';
      descEn = 'Dedicated 8-channel standalone ECU engineered for V8 and V6 engines. Delivers full 8-cylinder sequential fuel and ignition, dual wideband lambda inputs, dual knock detection, and high-speed CAN-bus data stream.';
      descEs = 'ECU programable de 8 canales dedicada para motores V8 y V6. Ofrece inyección e ignición secuencial completa de 8 cilindros, doble entrada de wideband lambda, doble sensor de knock y transmisión de datos CAN-bus de alta velocidad.';
      contextNoteEn = context === 'swap'
        ? '💡 <strong>Swap Note for V6/V8 (LS, Coyote, 2JZ, VQ35):</strong> Gold provides 8 individual ignition & injection channels plus CAN-bus output to communicate directly with digital dashes and aftermarket transmission controllers.'
        : '💡 <strong>Wiring Tip:</strong> Dedicated 8 channels allow running true sequential V8 without sharing coil drivers or injector channels.';
      contextNoteEs = context === 'swap'
        ? '💡 <strong>Nota para Swaps V6/V8 (LS, Coyote, 2JZ, VQ35):</strong> La Gold provee 8 canales individuales de inyección e ignición más salida CAN-bus para comunicarse con pantallas digitales (digital dash) y controladores de transmisión.'
        : '💡 <strong>Consejo de Realambrado:</strong> 8 canales dedicados permiten inyección e ignición 100% secuencial en V8 sin tener que emparejar bobinas o inyectores.';
    } else if (cylinderChoice === 'advanced') {
      recProduct = universals.find(function (u) { return u.ProductID === 'PROD-UNI-PLATINUM'; }) || {
        Name: 'AlphaECU Platinum',
        MSRP: '$1,999',
        ProcessorArch: 'Dual STM32 High-Speed Architecture',
        Channels: '12 Injector / 12 Ignition / Dual DBW / 4 VVT / Dual CAN'
      };
      storeHandle = 'alphaecu-platinum';
      descEn = 'Flagship 12-channel ECU designed for extreme motorsport setups, twin turbos, multi-stage nitrous, water/methanol injection, multiple temperature probes, dual drive-by-wire throttles, and 10/12-cylinder engines.';
      descEs = 'ECU insignia de 12 canales diseñada para automovilismo extremo, twin turbo, nitro por etapas, inyección de agua/metanol, múltiples sensores de temperatura, doble cuerpo de aceleración electrónico (Dual DBW) y motores de 10 y 12 cilindros.';
      contextNoteEn = '🔥 <strong>High-Performance Motorsport:</strong> Platinum provides expansive I/O for multiple EGT sensors, intercooler/oil/transmission temp sensors, dual CAN-bus networks, and closed-loop boost/traction control.';
      contextNoteEs = '🔥 <strong>Motorsport de Alto Nivel:</strong> La Platinum ofrece amplia capacidad de entradas para sensores EGT, temperaturas de intercooler/aceite/transmisión, doble red CAN-bus y control de boost/tracción en lazo cerrado.';
    }

    if (!recProduct) return;

    const cylTextEn = cylinderChoice === '4cyl' ? '4-Cylinder' : (cylinderChoice === 'v6v8' ? 'V6 / V8' : 'Advanced Motorsport');
    const cylTextEs = cylinderChoice === '4cyl' ? '4 Cilindros' : (cylinderChoice === 'v6v8' ? 'V6 / V8' : 'Automovilismo Avanzado');
    const archTextEn = cylinderChoice === '4cyl' ? '4-Cylinder Sequential' : (cylinderChoice === 'v6v8' ? 'V6 / V8 Sequential' : 'Up to 12-Cylinder / Multi-Power Adder');
    const archTextEs = cylinderChoice === '4cyl' ? '4 Cilindros Secuencial' : (cylinderChoice === 'v6v8' ? 'V6 / V8 Secuencial' : 'Hasta 12 Cilindros / Múltiples Agregados');

    const desc = currentLang === 'es' ? descEs : descEn;
    const note = currentLang === 'es' ? contextNoteEs : contextNoteEn;
    const cylLabel = currentLang === 'es' ? cylTextEs : cylTextEn;
    const archLabel = currentLang === 'es' ? archTextEs : archTextEn;

    let html = `
      <div class="ax-result-card">
        <div class="ax-result-top">
          <div class="ax-result-title-group">
            <div class="ax-choice-badge" style="background: rgba(16, 185, 129, 0.15); color: #34d399; border-color: rgba(16, 185, 129, 0.3);">
              ${t.recBadgePrefix} ${cylLabel} ${t.recBadgeSuffix}
            </div>
            <h2>${recProduct.Name}</h2>
            <div class="ax-result-subtitle">${recProduct.ProcessorArch || 'STM32 Architecture'}</div>
          </div>
          <div class="ax-result-price-box">
            <div class="ax-price-tag">${recProduct.MSRP || '$599'}</div>
            <div class="ax-price-label">${t.msrpLabel}</div>
          </div>
        </div>

        <div class="ax-specs-grid">
          <div class="ax-spec-item">
            <div class="ax-spec-label">${t.labelChannelCap}</div>
            <div class="ax-spec-val highlight">${recProduct.Channels || 'High-Output Channels'}</div>
          </div>
          <div class="ax-spec-item">
            <div class="ax-spec-label">${t.labelEngineArch}</div>
            <div class="ax-spec-val">${archLabel}</div>
          </div>
          <div class="ax-spec-item">
            <div class="ax-spec-label">${t.labelProcessor}</div>
            <div class="ax-spec-val">${recProduct.ProcessorArch || 'STM32 Fast Core'}</div>
          </div>
        </div>

        <div class="ax-result-desc-box">
          ${desc}
        </div>

        <div class="ax-result-desc-box" style="border-left-color: #10b981; background: rgba(16, 185, 129, 0.08); color: #ecfdf5; margin-bottom: 20px;">
          ${note}
        </div>

        <div class="ax-actions-row">
          <a href="https://alphaxpr.com/products/${storeHandle}" class="ax-btn ax-btn-primary" target="_blank" rel="noopener">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            ${t.btnBuyNow} &rarr;
          </a>
        </div>
      </div>
    `;

    targetContainer.innerHTML = html;
  }

  function highlightBudgetCard(recId) {
    if (!dom.budgetCards) return;
    dom.budgetCards.forEach(function (card) {
      card.style.borderColor = '';
      card.style.boxShadow = '';
      card.style.transform = '';
    });

    const targetCard = document.querySelector('.ax-budget-card.' + recId);
    if (targetCard) {
      targetCard.style.borderColor = '#10b981';
      targetCard.style.boxShadow = '0 0 25px rgba(16, 185, 129, 0.4)';
      targetCard.style.transform = 'translateY(-6px)';
      targetCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function generateProductCardHtml(product, type) {
    const t = I18N[currentLang];
    const productSlug = product.Name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    const inStock = product.StockQty && parseInt(product.StockQty) > 0;

    return `
      <div class="ax-result-card">
        <div class="ax-result-top">
          <div class="ax-result-title-group">
            <div class="ax-choice-badge" style="background: rgba(37, 99, 235, 0.15); color: #60a5fa;">
              ${t.pnpBadgeMatch}
            </div>
            <h2>${product.Name}</h2>
            <div class="ax-result-subtitle">${currentLang === 'es' ? 'Aplicación:' : 'Application:'} ${product.Model}</div>
          </div>
          <div class="ax-result-price-box">
            <div class="ax-price-tag">${product.MSRP || 'Inquire'}</div>
            <div class="ax-price-label">${t.msrpLabel}</div>
          </div>
        </div>

        <div class="ax-specs-grid">
          <div class="ax-spec-item">
            <div class="ax-spec-label">${currentLang === 'es' ? 'Marca' : 'Make'}</div>
            <div class="ax-spec-val">${product.Make}</div>
          </div>
          <div class="ax-spec-item">
            <div class="ax-spec-label">${currentLang === 'es' ? 'Canales / Funciones' : 'Features / Channels'}</div>
            <div class="ax-spec-val highlight">${product.Channels || 'Factory PNP'}</div>
          </div>
          <div class="ax-spec-item">
            <div class="ax-spec-label">${t.labelProcessor}</div>
            <div class="ax-spec-val">${product.ProcessorArch || 'STM32 Core'}</div>
          </div>
          <div class="ax-spec-item">
            <div class="ax-spec-label">${t.labelAvailability}</div>
            <div class="ax-spec-val" style="color: ${inStock ? '#34d399' : '#fbbf24'}">
              ${inStock ? t.inStockText : t.builtToOrderText}
            </div>
          </div>
        </div>

        <div class="ax-result-desc-box">
          ${product.Description || (currentLang === 'es' ? 'Computadora Plug and Play de reemplazo directo para conectar al arnés de fábrica.' : 'Direct plug and play replacement ECU designed to connect directly into the OEM factory engine wiring harness.')}
        </div>

        <div class="ax-actions-row">
          <a href="https://alphaxpr.com/products/${productSlug}" class="ax-btn ax-btn-primary" target="_blank" rel="noopener">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            ${t.btnBuyNow} &rarr;
          </a>
        </div>
      </div>
    `;
  }

  // Expose global helper for inline buttons
  window.axChoiceHelper = {
    selectSituation: selectSituation,
    showView: showView,
    resetState: resetState,
    setLanguage: setLanguage
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
